<div class="icon-button" woa-touchable
     [ngClass]="{
         'circular': circular(),
         'enlarged': enlarged()
     }"
     [woa-css-var]="{'--default-icon-size': defaultIconSize() + 'px'}">
    <woa-icon class="icon-button-icon" [name]="iconName()"></woa-icon>
</div>
